import React from 'react';
import PropTypes from 'prop-types';

import { PreviewCondition } from '@sopranodesign/pulse-components';

import ConditionPreview from '../../ConditionPreview';

const UrlPreview = ({ prefix = 'When', ...props }) => (
  <p>
    {prefix}
    {props.flipped === 1 && ' not'} page url
    <PreviewCondition>{props.type.name}</PreviewCondition>
    <ConditionPreview {...props} />
  </p>
);

UrlPreview.propTypes = {
  prefix: PropTypes.string,
  flipped: PropTypes.number,
  type: PropTypes.shape({ type: PropTypes.string, name: PropTypes.string })
};

export default UrlPreview;
